export interface CaseActAttachmentView {
  idCaseActAttachment: number;
  name: string;
  createdDate: Date;
  lastValidSignature: string;
  lastSignerInstitution: string;
  status: boolean;
}

export interface CaseActRequestDescriptionModel {
  caseActRequestDescription: string;
}

export const initialCaseActRequestDescriptionModel: CaseActRequestDescriptionModel = {
  caseActRequestDescription: ''
};
